import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastService } from '../../main/bootstrap/toast/ToastService';
import { AuthenticationService } from '../../core';
import { FormBuilder } from '@angular/forms';
import { ApiService } from '../../../services/api.service';
import { HttpClient } from '@angular/common/http';
import { Utility } from "../../utility/utility";
import { Utils } from "../../util/utility";
import {finalize} from "rxjs/operators";

@Component({
  selector: 'app-company-dashboard',
  templateUrl: './company-dashboard.component.html',
  styleUrls: ['./company-dashboard.component.css']
})
export class CompanyDashboardComponent implements OnInit {
  regInfo: any;
  paymentInfo: any;
  loading = false;
  canUpdateCompany = false;
  classificationId: number;
  companyType: any;

  constructor(private router: Router,
              public toastService: ToastService,
              public authService: AuthenticationService,
              public formBuilder: FormBuilder,
              public apiService: ApiService,
              public http: HttpClient) {

    this.regInfo = JSON.parse(sessionStorage.getItem('regInfo'));
    this.paymentInfo = JSON.parse(sessionStorage.getItem('paymentInfo'));
    this.classificationId = Utility.getClassificationId(this.regInfo);
    this.companyType = Utils.getCompanyType(this.regInfo);
    const id: string = JSON.stringify(this.classificationId);

    if(id == '5'){
      sessionStorage.setItem('paymentIdClassification', "21539");
    }
    if(id == '4'){
      sessionStorage.setItem('paymentIdClassification', "21538");
    }
    if(id == '3'){
      sessionStorage.setItem('paymentIdClassification', "6565");
    }
    if(id == '2'){
      sessionStorage.setItem('paymentIdClassification', "6564");
    }
    if(id == '1'){
      sessionStorage.setItem('paymentIdClassification', "6123");
    } else{
      sessionStorage.setItem('paymentIdClassification', "6564");
    }

    this.canUpdateCompany = JSON.parse(localStorage.getItem('canUpdateCompany'));
  }

  ngOnInit(): void {
    sessionStorage.setItem('paymentIdCompany', this.regInfo.id);
    sessionStorage.removeItem('allowToReduceAllotment');
    if(!this.canUpdateCompany){
      this.router.navigate(['/dashboard']);
    }
  }

  checkForOngoingShareUpdate(){
    if (this.loading) return;

    this.loading = true;
    this.apiService.get_(`/share-details/change-in-allotment-status/${this.regInfo.id}`)
      .pipe(finalize(() => { this.loading = false; }))
      .subscribe({
        next: (res) => {
          if(res.success){
            this.toastService.showDanger(res?.message || 'Cannot proceed with change in share capital!');
            return;
          }

          this.router.navigateByUrl('/company-registration/statement-of-capital');
        },
        error: (err) => {
          this.toastService.showDanger(err.error?.message || err?.message || 'Failed to check changes in allotment!');
        }
      })
  }
}
